import React from "react";
import "../Header.css";

function NavBar({
  isShowAuthForm,
  setIsShowAuthForm,
  isSignInProcess,
  setIsSignInProcess,
  isRegisterProcess,
  setIsRegisterProcess,
}) {
  const handleAuthBtnClick = (e) => {
    setIsShowAuthForm(true);
    if (e.target.value === "register") {
      setIsRegisterProcess(true);
      setIsSignInProcess(false);
    } else if (e.target.value === "sign in") {
      setIsSignInProcess(true);
      setIsRegisterProcess(false);
    }
    document.getElementById("app-root").style.filter = "blur(7px)";
  };

  return (
    <div className="navbar">
      <button
        value="sign in"
        className="loginicon"
        onClick={(e) => handleAuthBtnClick(e)}
      >
        Sign In
      </button>

      <button
        value="register"
        className="loginicon"
        onClick={(e) => handleAuthBtnClick(e)}
      >
        Register
      </button>
    </div>
  );
}

export default NavBar;
